/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".widget[_ngcontent-%COMP%]{display:block;width:100%;height:100%;position:relative}.widget__container[_ngcontent-%COMP%]{position:absolute;padding:8px}.widget__frame[_ngcontent-%COMP%]{display:block;width:100%;height:100%;box-shadow:0 0 0 1px #eaeff5}"];
export { styles as styles };
